<template>
    <div>
        <div class="pageback"></div>
        <div class="pagemain">
            <div class="container">
                <div class="row">
                    <div class="col-sm-2" v-if="webW">
                        <div id="JfLeftMenuOut">
                            <div :class="(fixedLeftmenu?'fixedMenuCls':'')"
                                 :style="fixedLeftmenu?('width:'+LeftMenuWidth+'px'):''" id="JfLeftMenu">
                                <AuthorLeft></AuthorLeft>
                            </div>
                            <div v-if="fixedLeftmenu" :style="'width:'+LeftMenuWidth+'px'"><br></div>
                        </div>


                    </div>
                    <div :class="(webW?'col-sm-7':'col-sm-12')">
                        <div style="overflow-x: hidden;">

                            <AuthorTop v-if="!webW"></AuthorTop>

                            <!-- <el-switch
                                    v-if="webW"

                                    @click="openAutoReflashFunc"
                                    :style="'position: absolute;z-index: 1;right:10px;margin-top:10px;'"
                                    active-text="下拉刷新"
                                    v-model="openAutoReflash"
                                    active-color="#13ce66"
                                    inactive-color="#dddddd">
                            </el-switch> -->

                            <el-tabs id="zhutiMain" v-model="type"  @tab-click="tabClick" style="background-color: #fff;padding-left: 10px;">
                                <el-tab-pane :label="(authorId==lander.uid?'我':'Ta')+'的文章'" v-if="type=='myforum'" name="myforum"></el-tab-pane>
                                <el-tab-pane :label="(authorId==lander.uid?'我':'Ta')+'的收藏'" v-if="type=='collect'" name="collect"></el-tab-pane>
                                <el-tab-pane :label="(authorId==lander.uid?'我':'Ta')+'的点赞'" v-if="type=='hit'" name="hit"></el-tab-pane>
                            </el-tabs>

                            <ForumItemMyForum></ForumItemMyForum>

                            <div class="baiseback">

                                <div>
<!--                                        <el-card class="box-card margintop20" v-for="(t,i) in homeData">-->
<!--                                            <div slot="header" class="clearfix">-->
<!--                                                 <span class="hander"  @click="goForumItemMyForum(t,i,'top')"> {{t.ftitle}}</span>-->
<!--                                                <el-button @click=" delhandle(t,i)" v-if="lander.uid==authorId" style="float: right; padding: 3px 0" type="text">取消{{type=='collect'?'收藏':'点赞'}}</el-button>-->
<!--                                            </div>-->
<!--                                            <p class="typedesc" >-->
<!--                                                你于 {{type=='collect'?t.collectTs:t.hitTs}} {{type=='collect'?'收藏':'点赞'}}了该主贴-->
<!--                                            </p>-->
<!--                                        </el-card>-->



                                </div>





                                <div class="baiseback"  v-if="homeDataloading">
                                    <div class="center">
                                        <img src="../../../assets/img/loading.gif">
                                        <p class="typedesc">数据加载中....</p>
                                    </div>
                                </div>
                                <div class="baiseback" style="height: 100vh;"  v-if="!homeDataloading&&homeData.length==0">
                                    <div class="center">
                                        <img src="../../../assets/img/zwsj.png">
                                        <p class="typedesc">暂无数据</p>
                                    </div>
                                </div>


                                <div class="center" >
                                    <el-pagination 
                                            @current-change="handlePageChange"
                                            :current-page="query.pageNo"
                                            :page-size="query.pageSize"
                                            layout="total, prev, pager, next"
                                            :total="pageTotal">
                                    </el-pagination>

                                </div>
                                <p class="typedesc center" v-if="homeDataFinish">没有数据了</p>
                            </div>
                            <div class="baiseback">
                                <Footer></Footer>
                            </div>
                        </div>
                    </div>


                     <div class="col-sm-3" v-if="webW">
                        <div id="JfRightMenuOut">
                            <div :class="(fixedRightmenu?'fixedMenuRT':'')" :style="fixedRightmenu?('width:'+RightMenuWidth+'px'):''" id="JfRightMenu">
                                 <AuthorTop></AuthorTop>
                            </div>
                          
                        </div>
                    </div>




                </div>
            </div>
        </div>
        <div class="h100"></div>
        <img src="../../../assets/img/top.png" @click="gotopFunc" v-if="scrolltop" class="gotop hander">
    </div>

</template>
<script>

    import {dealResult, getWindowWidth} from '../../../api/common'
    import {collectHitForumPage, cancelForumCollectHit, authorForumpage} from '../../../api';


    import Footer from "../Footer";
    import AuthorTop from "./AuthorTop";
    import AuthorLeft from "./AuthorLeft";
    import ForumItemMyForum from "../index/ForumItemMyForum";
    import  PubSub from 'pubsub-js'
    export default {
        name: 'Home',
        components: {
            Footer,
            AuthorTop,
            AuthorLeft,
            ForumItemMyForum

        },

        data() {
            return {
                webW:true,

                openAutoReflash: false,
                scrolltop: false,

                nouse: false,//禁用
                //菜单固定
                fixedLeftmenu: false,
                LeftMenuWidth: 0,
                RightMenuWidth: 0,
                scrolltop:false,

                nouse:false,//禁用
                fixedRightmenu: false,
                lander: {},
                type:'myforum',
                authorId:'',


                // 信息
                homeData: [],
                homeDataloading:true,
                homeDataFinish:false,//避免滚动条在最后一直请求

                query: {
                    tyepId: '',
                    pageNo: 1,
                    pageSize: 10,
                },
                pageTotal: 0,



            };
        },
        methods: {
            goForumItemMyForum(t, index, type) {
                this.$router.push('ForumDetail?id=' + t.forumId + "&type=" + type);
            },

            gotopFunc() {
                if(document.documentElement!=undefined)document.documentElement.scrollTop=0;
                if(document.body!=undefined) document.body.scrollTop=0;
            },

            tabClick(tab, event) {

               this.query.pageNo=1;
               this.homeData=[];
                PubSub.publish('forumDataListForItem_home',null);
                this.homeDataFinish=false;
               this.getPage();
            },


            openAutoReflashFunc(){
                if(this.openAutoReflash)this.homeDataFinish=false;
            },

            // 分页导航
            handlePageChange(val) {
                this.query.pageNo = val;
                this.homeData=[];
                PubSub.publish('forumDataListForItem_home',null);
                this.getPage();

                this.homeDataFinish=false;

                let forumMain=document.getElementById('zhutiMain');
                let top=forumMain.offsetTop;
                document.documentElement.scrollTop=top;
                 document.body.scrollTop=top;

            },



            //获取帖子分页
            getPage() {
                let o={
                    uid:this.lander.uid,
                    token: this.lander.token,
                    pageNo:this.query.pageNo,
                    pageSize:this.query.pageSize,
                }
                this.homeDataloading=true;
                this.homeDataFinish=false;

                if(this.type=='myforum'){
                    o.authorUid=this.authorId;
                    this.getauthorForumpage(o);
                }
                else{
                    o.actionUid=this.authorId;
                    o.type=this.type;
                    this.getCollectHitForumPage(o);
                }


            },
            getCollectHitForumPage(o){
                collectHitForumPage( o).then((res) => {
                    this.homeDataloading=false;
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        let li= res.data.obj.list;
                        if(li.length==0){
                            this.homeDataFinish=true;
                            return ;
                        }
                        for(let i=0;i<li.length;i++){
                            li[i].hidden=true;
                            li[i].showComments=false;
                            li[i].commentli=[];
                            li[i].commentliLoading=false;

                            li[i].iscollect="0";
                            li[i].ishit="0";

                           li[i].id=li[i].forumId;//为了于forumitem里的数据保持一致


                            li[i].voteItemli=[];
                            li[i].ivote='0';
                            li[i].myvoteDx='';
                            li[i].myvoteMx=[];

                            li[i].nowvideo={vindex:0,isshow:'0'};
                        }
                        this.homeData=this.homeData.concat(li);
                        PubSub.publish('forumDataListForItem_home',li);

                        this.pageTotal = res.data.obj.total//该页总共多少条记录

                        if( this.openAutoReflash  ) {
                            if( res.data.obj.hasNextPage )this.query.pageNo=res.data.obj.nextPage;
                            else this.query.pageNo=this.query.pageNo+1;
                        }

                        this.fixedmenu();


                    }else {
                        this.homeDataFinish=true;
                        this.$message.error(res.data.msg)
                    }
                })
            },
            getauthorForumpage(o){
                authorForumpage( o).then((res) => {
                    this.homeDataloading=false;
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        let li= res.data.obj.list;
                        if(li.length==0){
                            this.$message.info('没有数据了');
                            this.homeDataFinish=true;
                            return ;
                        }
                        for(let i=0;i<li.length;i++){
                            li[i].hidden=true;
                            li[i].showComments=false;
                            li[i].commentli=[];
                            li[i].commentliLoading=false;

                            li[i].iscollect="0";
                            li[i].ishit="0";


                            li[i].voteItemli=[];
                            li[i].ivote='0';
                            li[i].myvoteDx='';
                            li[i].myvoteMx=[];

                            li[i].nowvideo={vindex:0,isshow:'0'};
                        }



                        this.homeData=this.homeData.concat(li);
                        PubSub.publish('forumDataListForItem_home',li);

                        this.pageTotal = res.data.obj.total//该页总共多少条记录

                        if( this.openAutoReflash  ) {
                            if( res.data.obj.hasNextPage )this.query.pageNo=res.data.obj.nextPage;
                            else this.query.pageNo=this.query.pageNo+1;
                        }

                        this.fixedmenu();


                    }else {
                        this.homeDataloading=true;
                        this.$message.error(res.data.msg)
                    }
                })
            },
            fixedmenu(){
                let that=this;
                window.onscroll = function () {

                    let t = document.documentElement.scrollTop || document.body.scrollTop;
                    let h = document.documentElement.scrollHeight  ;
                    let wh = document.documentElement.clientHeight  ;
                    if (that.webW) {
                        let JfLeftMenu = document.getElementById('JfLeftMenu');
                        let JfRightMenu = document.getElementById('JfRightMenu');
                        that.LeftMenuWidth = JfLeftMenu.offsetWidth;
                        that.RightMenuWidth = JfRightMenu.offsetWidth;

                        //t+wh=h

                        //必须写到onscroll里，因为高度是会变化的
                        let leftHeight = JfLeftMenu.offsetHeight;
                        let leftTop = JfLeftMenu.offsetTop;
                        if (t > leftTop + leftHeight) {
                            that.fixedLeftmenu = true;
                        } else {
                            that.fixedLeftmenu = true;
                        }
                        let rightHeight = JfRightMenu.offsetHeight;
                        let rightTop = JfRightMenu.offsetTop;
                        if (t > rightTop + rightHeight + 50) {
                            that.fixedRightmenu = true;
                        } else {
                            that.fixedRightmenu = true;
                        }

                    }


                    //出现回到顶部按钮
                    if (t > wh) that.scrolltop = true;
                    else that.scrolltop = false;
                    //滚动条到底部加载数据
                    if(t+wh>=h-100 && that.openAutoReflash && !that.homeDataFinish){

                        if(!that.homeDataloading)that.getPage();
                    }
                }

            },
            delhandle(t,index){
                if(this.lander.uid!=this.authorId)return;
                    this.$confirm("确定取消？  " , "提示", {
                        type: "warning",
                    }) .then(() => {
                        this.loading = this.$loading({
                            lock: true,
                            text: "请求中...",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.5)",
                        });
                        let o={ id:t.id,uid:this.lander.uid,token:this.lander.token,type:this.type   }
                        cancelForumCollectHit( o).then((res) => {
                            this.loading.close();
                            dealResult(res.data);
                            if (res.data.status == 1) {
                                this.$message.success(res.data.msg)
                                this.homeData.splice(index,1);
                            } else{
                                this.$message.error(res.data.msg)
                            }
                        })
                    });
            }

        }, mounted() {
            this.webW=getWindowWidth()>=1000?true:false;
            this.lander = JSON.parse(this.$store.state.logininfo);
            //固定左右菜单
            this.fixedmenu();
            if(this.$route.query.type==undefined)this.type="myforum";
            if(this.$route.query.type!="collect"&&this.$route.query.type!="hit"&&this.$route.query.type!="myforum")this.type="myforum";
            else this.type=this.$route.query.type;
            if(this.$route.query.authorId!=undefined){
                this.authorId = this.$route.query.authorId;
                this.query.pageNo=1;
                this.homeData=[];
                PubSub.publish('forumDataListForItem_home',null);
                this.getPage()
            }


        }, watch:{
            $route:function(value){
                if((value.query.type=="myforum"||value.query.type=="hit"||value.query.type=="collect")&&value.query.authorId!=undefined){
                    if(this.authorId!=value.query.authorId||this.type!=value.query.type){
                        this.type=value.query.type;
                        this.authorId=value.query.authorId;

                        this.query.pageNo=1;
                        this.homeData=[];
                        PubSub.publish('forumDataListForItem_home',null);
                        this.getPage();

                    }
                }
                this.fixedmenu();
            }
        },
        activated() {
            //固定左右菜单
            this.fixedmenu();
        },
        deactivated() {
        }

    };
</script>
<style scoped>

</style>
